import { render } from "./ComponentSharedWithMeNoData.vue?vue&type=template&id=c5e1af20"
import script from "./ComponentSharedWithMeNoData.vue?vue&type=script&lang=js"
export * from "./ComponentSharedWithMeNoData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__